export const config = {
    gate_way_url : process.env.GATE_WAY_URL || process.env.REACT_APP_SERVER
}